import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

/**
 * Gets the height of the range without ignoring zero width rectangles, which
 * some browsers ignore when creating a union.
 *
 * @param {Range} range The range to check.
 * @return {number | undefined} Height of the range or undefined if the range has no client rectangles.
 */
export default function getRangeHeight(range) {
  var rects = Array.from(range.getClientRects());

  if (!rects.length) {
    return;
  }

  var highestTop = Math.min.apply(Math, _toConsumableArray(rects.map(function (_ref) {
    var top = _ref.top;
    return top;
  })));
  var lowestBottom = Math.max.apply(Math, _toConsumableArray(rects.map(function (_ref2) {
    var bottom = _ref2.bottom;
    return bottom;
  })));
  return lowestBottom - highestTop;
}
//# sourceMappingURL=get-range-height.js.map